/*
 * @Description:
 * @Author: cooky
 * @Date: 2021-02-25 17:17:51
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-09 11:48:52
 */
import axios from '@/util/request'

const USER_LOGIN = '/login/AccountLogin'
const GET_SERVER_AND_ROLE = '/bind/GetAllRole'
const SEND_BIND_ROLE_VERIFY_CODE = '/bind/SendVerifyCode'
const BIND_ROLE = '/bind/BindRole'
const SET_CURRENT_ROLE = '/bind/SetCurrentRole'
const GET_ALL_SERVER = '/bind/GetAllServer'
const GET_COMMODITY = '/commodity/GetRoleCommodity'
const PAY = '/commodity/Pay'
const GET_ALL_APP = '/bind/GetAllApp'
const QUERY_PAYING_STATUS = '/callback/PayResult'

const LOGICAL_REGION_ID = parseInt(process.env.VUE_APP_LOGICAL_REGION_ID)

export function accountLogin (data) {
  return axios.post(USER_LOGIN, {
    logical_region_id: LOGICAL_REGION_ID,
    ...data
  })
}

export function getServerAndRole () {
  console.log('GetAllRole=======')
  // return new Promise()
  return axios.post(GET_SERVER_AND_ROLE, {})
}

export function sendBindRoleVerifyCode (data) {
  return axios.post(SEND_BIND_ROLE_VERIFY_CODE, data)
}

export function bindRole (data) {
  return axios.post(BIND_ROLE, data)
}

export function setCurrentRole (data) {
  return axios.post(SET_CURRENT_ROLE, data)
}

export function getAllServer () {
  return axios.post(GET_ALL_SERVER, {
    logical_region_id: LOGICAL_REGION_ID
  })
}

export function getCommodity () {
  return axios.post(GET_COMMODITY, {})
}
export function getRecommandGoods () {
  return axios.post(GET_COMMODITY, {})
}

export function pay (data) {
  return axios.post(PAY, data)
}

export function getAllApp () {
  return axios.post(GET_ALL_APP, {})
}
// 查询支付结果
export function queryPayingStatus (uid) {
  return axios.post(QUERY_PAYING_STATUS, {
    uid
  })
}
// 埋点
export function burying (data) {
  console.log('埋点11：', data)
  axios.defaults.baseURL = '/v2'
  return axios.post('/extension_event', data)
}
